<div class="layout-column full-height full-width">

  <!--Query Row-->
  <div class="layout-row layout-align-start-center padding-10 md-whiteframe-z1">

    <!--Search Box-->
    <app-bringoz-search-input class="flex"
                              [placeholder]="'Search Agent'"
                              [query]="queryString"
                              (queryChangeEvent)="onQueryChange($event)">
    </app-bringoz-search-input>
  </div>

  <div class="flex layout-column bringoz-table bringoz-table-sticky" [hidden]="assistants.length === 0">

    <!--Table Header-->
    <div class="tr layout-row layout-align-start-center">
      <div class="th xsmall"></div>
      <div class="th flex" translate>Agent</div>
    </div>

    <cdk-virtual-scroll-viewport class="flex viewport" (scroll)="getNextBatch()" autosize>
      <div *cdkVirtualFor="let agent of assistants"
           class="tr agent-row layout-row layout-align-start-center pointer"
           [class.disabled]="excludeKeys[agent.id]"
           [class.selected]="selectedKeys[agent.id]"
           (click)="!excludeKeys[agent.id] && onToggleAssistant(agent)">

        <div class="td xsmall layout-row layout-align-start-center">
          <app-bringoz-checkbox [isChecked]="selectedKeys[agent.id]"
                                (clickEvent)="onSelect(agent); $event.stopPropagation()">
          </app-bringoz-checkbox>
        </div>

        <app-agent-avatar [agent]="agent" class="margin-top-10" size="small"></app-agent-avatar>

        <div class="flex layout-column">
          <div class="layout-row layout-align-start-center gap-5">
            <span class="text-ellipsis br-body-2 font-weight-600">
              {{ agent.user | userName }}
            </span>
            <app-agent-assistant-mode [agent]="agent"></app-agent-assistant-mode>
          </div>
          <div class="layout-row layout-align-start-center">
            <span class="font-weight-400 br-caption-2">{{ 'AGENT_TYPES.' + agent.agentType | translate }}</span>
            <app-vehicle-type class="margin-left-5" [type]="agent.vehicle.type"></app-vehicle-type>
          </div>
          <span bringoz-ppi hide show-xs class="br-caption-2">{{ agent.user.mobilePhone | bringozPhone }}</span>
          <span class="font-weight-400 br-caption-2">{{ agent.employmentType | translate }}</span>
        </div>

      </div>
    </cdk-virtual-scroll-viewport>
  </div>

  <div *ngIf="assistants.length === 0 && !isLoading"
       class="flex layout-row layout-align-center-center fade-element-in-only overflow-auto">
    <app-empty-state [src]="'assets/images/empty_state/empty_state_drivers.png'"
                     [text]="'No Agents Found' | translate">
    </app-empty-state>
  </div>

  <!--Loading Mode-->
  <div *ngIf="isLoading"
       class="layout-row layout-align-center-center padding-10"
       [class.flex]="assistants.length === 0">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <div class="layout-row layout-align-start-center flex-10 padding-5">
    <span class="flex"></span>
    <div class="layout-align-center-center padding-right-10">
      <bringoz-button [theme]="'primary'"
                      [isDisabled]="!selectedIds?.length"
                      (onClick)="onAssignAssistant()">
        <span translate>Assign Assistant</span>
      </bringoz-button>
    </div>
  </div>
</div>
